import React, { useState, useEffect, useRef } from 'react';
import './Testimonials.css';
import testimonialsService from '../services/testimonialsService';

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [currentIndex, setCurrentIndex] = useState(0);

  const categories = [
    { id: 'all', name: 'Todos', icon: 'star' },
    { id: 'tienda', name: 'Tienda', icon: 'shopping-cart' },
    { id: 'bienestar', name: 'Bienestar', icon: 'spa' }
  ];

  const touchStartX = useRef(null);

  useEffect(() => {
    fetchTestimonials();
    const interval = setInterval(fetchTestimonials, 30 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (testimonials.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % testimonials.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [testimonials.length]);

  const fetchTestimonials = async () => {
    try {
      const testimonialsData = await testimonialsService.fetchTestimonials();
      setTestimonials(testimonialsData);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching testimonials:', error);
      setLoading(false);
    }
  };

  const filteredTestimonials = filter === 'all' 
    ? testimonials 
    : testimonials.filter(t => t.category === filter);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % filteredTestimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => 
      prev === 0 ? filteredTestimonials.length - 1 : prev - 1
    );
  };

  const goToTestimonial = (index) => {
    setCurrentIndex(index);
  };

  const navigateToPage = (path) => {
    window.history.pushState({}, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  const handleTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
  const handleTouchEnd = (e) => {
    if (touchStartX.current === null || filteredTestimonials.length < 2) return;
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) diff > 0 ? nextTestimonial() : prevTestimonial();
    touchStartX.current = null;
  };

  if (loading) {
    return (
      <section className="testimonials-section">
        <div className="testimonials-loading">
          <i className="fas fa-spinner fa-spin"></i>
          <span>Cargando testimonios...</span>
        </div>
      </section>
    );
  }

  return (
    <section id="testimonios" className="testimonials-section">
      <div className="testimonials-layout">
        {/* Columna izquierda: título y filtros */}
        <div className="testimonials-side">
          <span className="testimonials-tag">EXPERIENCIAS REALES</span>
          <h2 className="testimonials-headline">Nuestra Comunidad</h2>
          <p className="testimonials-subtitle">
            Personas que han confiado en Javiland
          </p>
          <div className="testimonial-filters">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => { setFilter(category.id); setCurrentIndex(0); }}
                className={`filter-btn ${filter === category.id ? 'active' : ''}`}
              >
                {category.name}
              </button>
            ))}
          </div>
          <button
            className="testimonials-cta"
            onClick={() => navigateToPage('/tienda')}
          >
            Comparte tu experiencia
          </button>
        </div>

        {/* Columna derecha: testimonio destacado */}
        {filteredTestimonials.length > 0 ? (
          <div className="testimonials-main">
            <div
              className="testimonials-carousel"
              onTouchStart={handleTouchStart}
              onTouchEnd={handleTouchEnd}
            >
              <button className="carousel-btn prev" onClick={prevTestimonial}>
                <i className="fas fa-chevron-left"></i>
              </button>
              <div className="testimonials-container">
                {filteredTestimonials.map((testimonial, index) => (
                  <div
                    key={testimonial.id}
                    className={`testimonial-card ${index === currentIndex ? 'active' : ''}`}
                  >
                    <p className="testimonial-quote">"{testimonial.message}"</p>
                    <div className="testimonial-meta">
                      <h3 className="testimonial-name">{testimonial.name}</h3>
                      <span className="testimonial-service">{testimonial.service}</span>
                      <span className="testimonial-date">
                        {new Date(testimonial.date).toLocaleDateString('es-ES', {
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric'
                        })}
                      </span>
                    </div>
                    <div className="testimonial-rating">
                      {[...Array(5)].map((_, i) => (
                        <i 
                          key={i} 
                          className={`fas fa-star ${i < testimonial.rating ? 'filled' : ''}`}
                        />
                      ))}
                    </div>
                  </div>
                ))}
              </div>
              <button className="carousel-btn next" onClick={nextTestimonial}>
                <i className="fas fa-chevron-right"></i>
              </button>
            </div>
            <div className="carousel-indicators">
              {filteredTestimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToTestimonial(index)}
                  className={`indicator ${index === currentIndex ? 'active' : ''}`}
                />
              ))}
            </div>
          </div>
        ) : (
          <div className="no-testimonials">
            <div className="no-testimonials-icon"><i className="fas fa-star"></i></div>
            <p><strong>Sé de los primeros en opinar.</strong></p>
            <p className="no-testimonials-sub">Tus palabras ayudan a otros a encontrar lo que buscan.</p>
            <button className="testimonials-cta" onClick={() => navigateToPage('/tienda')}>
              Compra y comparte tu experiencia
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Testimonials;
